class CollectionTabsSlider {
  constructor(sliderElement) {
    this.sliderElement = sliderElement;
    this.sectionId = sliderElement.dataset.sectionId;
    this.tabIndex = sliderElement.dataset.tabIndex;
    this.columnsMobile = parseFloat(sliderElement.dataset.columnsMobile || 1, 10);
    this.columnsDesktop = parseFloat(sliderElement.dataset.columnsDesktop || 2, 10);
    this.swiper = null;

    this.initSlider();
  }

  initSlider() {
    const sliderBox = this.sliderElement.closest('.tabs-slider-box');

    this.swiper = new Swiper(this.sliderElement, {
      loop: true,
      centeredSlides: false,
      slidesPerView: this.columnsMobile,
      slideToClickedSlide: false,
      spaceBetween: 20,
      grabCursor: true,
      longSwipesMs: 500,
      longSwipesRatio: 1,
      navigation: {
        nextEl: sliderBox ? sliderBox.querySelector('.slider-arrow-next') : null,
        prevEl: sliderBox ? sliderBox.querySelector('.slider-arrow-prev') : null,
      },
      breakpoints: {
        750: {
          loop: false,
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 2,
        },
        1099: {
          loop: true,
          slidesPerView: this.columnsDesktop,
          spaceBetween: 30,
        },
      },
    });
  }

  update() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  slideNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slidePrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }
}

const collectionTabsSliderInstances = new Map();

function getActiveTabSlider(cwt) {
  const activePanel = cwt.querySelector('.tabs-tab-panel.active .tabs-collection-slider');
  return activePanel || null;
}

function getActiveTabSliderInstance(cwt) {
  const slider = getActiveTabSlider(cwt);
  if (!slider) return null;
  return collectionTabsSliderInstances.get(slider) || null;
}

function initTabSlider(sliderElement) {
  if (!sliderElement || collectionTabsSliderInstances.has(sliderElement)) {
    return collectionTabsSliderInstances.get(sliderElement);
  }

  const instance = new CollectionTabsSlider(sliderElement);
  collectionTabsSliderInstances.set(sliderElement, instance);
  return instance;
}

function destroyTabSlider(sliderElement) {
  const instance = collectionTabsSliderInstances.get(sliderElement);
  if (instance) {
    instance.destroy();
    collectionTabsSliderInstances.delete(sliderElement);
  }
}

function initActiveTabSlider(cwt) {
  const activeSlider = getActiveTabSlider(cwt);
  if (!activeSlider) return;

  const instance = initTabSlider(activeSlider);
  if (instance) {
    instance.update();
  }
}

function collectionWithTabs() {
  const tabsWidth = window.innerWidth;
  const cwts = document.querySelectorAll('.collections-with-tabs');

  cwts.forEach((cwt) => {
    if (!cwt) return;

    const cwtNavigationItems = cwt.querySelectorAll('.tabs-navigation-item');
    const cwtNavigationSelect = cwt.querySelector('.tabs-navigation-select');
    const cwtPanels = cwt.querySelectorAll('[data-tab-id]');

    const activateTab = (item) => {
      const tagid = item.dataset ? item.dataset.tab : item.value;

      cwtNavigationItems.forEach((element) => element.classList.remove('active'));
      cwtPanels.forEach((element) => element.classList.remove('active'));

      if (item.classList) {
        item.classList.add('active');
      }

      const tabElement = cwt.querySelector(`[data-tab-id="${tagid}"]`);
      if (tabElement) {
        tabElement.classList.add('active');
      }

      initActiveTabSlider(cwt);
    };

    if (cwt.dataset.tabsInitialized === 'true') {
      initActiveTabSlider(cwt);
      return;
    }

    cwt.dataset.tabsInitialized = 'true';

    if (tabsWidth >= 990) {
      cwtNavigationItems.forEach((item) => {
        item.addEventListener('click', () => activateTab(item));
        item.addEventListener('keyup', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            activateTab(item);
          }
        });
      });
    } else if (cwtNavigationSelect) {
      cwtNavigationSelect.addEventListener('change', () => activateTab(cwtNavigationSelect));
    }

    initActiveTabSlider(cwt);
  });
}

function destroyCollectionTabsSlidersInSection(section) {
  section.querySelectorAll('.tabs-collection-slider').forEach((slider) => {
    destroyTabSlider(slider);
  });

  const cwt = section.querySelector('.collections-with-tabs');
  if (cwt) {
    delete cwt.dataset.tabsInitialized;
  }
}

document.addEventListener('DOMContentLoaded', collectionWithTabs);
document.addEventListener('shopify:section:load', collectionWithTabs);
document.addEventListener('shopify:section:unload', (event) => {
  destroyCollectionTabsSlidersInSection(event.target);
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.collections-with-tabs').forEach((cwt) => {
    const instance = getActiveTabSliderInstance(cwt);
    if (instance) {
      instance.update();
    }
  });
});
